import axios from "axios";

const API = axios.create({
  baseURL: "https://api.ilogically.com/api/notification/meta"
});

export const getBatches = () =>
  API.get("/batches");

export const searchUsers = (search) =>
  API.get("/users", { params: { search } });

export const getSegments = () =>
  API.get("/segments");
